import React from 'react';
import { Link } from 'react-router-dom';
import { theme, Tooltip } from 'antd';

import { AgingTicket } from '@totem/components/ticketing/agingDashboard/types';

// Ticket number link with its summary clamped to one line (full text in the tooltip).
const TicketCell = ({ ticket }: { ticket: AgingTicket }) => {
  const { token } = theme.useToken();

  return (
    <>
      <Link to={`/dashboard/ticket/${ticket.id}`}>{ticket.number}</Link>
      {ticket.summary && (
        <Tooltip title={ticket.summary}>
          <div
            style={{
              color: token.colorTextSecondary,
              fontSize: 12,
              maxWidth: 280,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {ticket.summary}
          </div>
        </Tooltip>
      )}
    </>
  );
};

export default TicketCell;
